import type { ComponentProps, FC } from 'react';

import { cva } from 'class-variance-authority';

import { Table } from '@repo/ui/components/common';
import { cn } from '@repo/utils/common';

export const headerVariants = cva('transition-colors', {
  variants: {
    isSelected: {
      true: 'bg-primary',
      false: 'bg-accent/20',
    },
  },
});

export const headVariants = cva('transition-colors', {
  variants: {
    isSelected: {
      true: 'text-white',
      false: 'text-primary',
    },
  },
});

export const titleVariants = cva('font-semibold lg:text-lg', {
  variants: {},
});

export const rowVariants = cva(
  [
    'cursor-pointer last:border-b!',
    'hover:bg-primary/10 focus-visible:bg-primary/10',
    'focus-visible:outline-primary focus-visible:outline',
    'focus-visible:border-b-transparent focus-visible:-outline-offset-1',
  ],
  {
    variants: {
      isEven: {
        true: 'bg-gray-100',
        false: 'bg-white',
      },
    },
  },
);

export const cellVariants = cva('', {
  variants: {
    title: {
      true: 'py-3 pl-4 text-left',
      false: '',
    },
    ident: {
      true: 'hidden text-center min-[640px]:table-cell',
      false: '',
    },
    width: {
      true: 'hidden text-center min-[800px]:table-cell',
      false: '',
    },
    weight: {
      true: 'hidden text-center min-[960px]:table-cell',
      false: '',
    },
    power: {
      true: 'hidden text-center min-[1024px]:table-cell',
      false: '',
    },
    price: {
      true: 'text-right',
      false: '',
    },
    action: {
      true: 'hidden w-[130px] text-right uppercase min-[480px]:table-cell',
      false: '',
    },
  },
});

export const MachineTable: FC<ComponentProps<typeof Table>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <Table className={cn('m-0 border-0 p-0', className)} {...props}>
      {children}
    </Table>
  );
};
